import axios from '../utils/axios'
import { getStaticConfigs, withServicePrefix } from "../helpers/common";
import { vmrsDelete, vmrsGet, vmrsPatch } from './vmrsApi';

const buildUrl = async (path: string) =>
{
   const staticConfigs = await getStaticConfigs();
   const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL;
   return `${baseUrl}${withServicePrefix(path)}`;
};

export async function getNotifications(params?: { skip?: number; limit?: number; is_read?: boolean })
{
   // const url = await buildUrl(`/api/v1/notifications`);
   // return axios.get(url, { params });

   return vmrsGet(`/api/v1/notifications`);
}

export async function getUnreadNotificationCount()
{
   // const url = await buildUrl(`/api/v1/notifications/unread-count`);
   // return axios.get(url);
   return vmrsGet(`/api/v1/notifications/unread-count`);
}

export async function markAllNotificationsRead()
{
   // const url = await buildUrl(`/api/v1/notifications/read-all`);
   // return axios.patch(url);

   return vmrsPatch(`/api/v1/notifications/read-all`);
}

export async function markNotificationRead(id: string | number)
{
   // const url = await buildUrl(`/api/v1/notifications/${id}/read`);
   // return axios.patch(url);

   return vmrsPatch(`/api/v1/notifications/${id}/read`);
}

export async function deleteNotification(id: string | number)
{
   // const url = await buildUrl(`/api/v1/notifications/${id}`);
   // return axios.delete(url);

   return vmrsDelete(`/api/v1/notifications/${id}`);
}
